import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
//style
import "./style.css";
//tab
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Table } from "reactstrap";
import DeleteIcon from "@material-ui/icons/Delete";
//form
import { TextField } from "@material-ui/core";
import axios from "axios";
import { useForm } from "react-hook-form";
import EditIcon from "@material-ui/icons/Edit";
//drop zoon
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import IntlMessages from "util/IntlMessages";
const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

//tab
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

//end tab
export default function User(props) {
  const { register, handleSubmit } = useForm();
  const [open, setOpen] = useState();

  useEffect(() => {
    if (props.open !== false) {
      getUser();
      setOpen(true);
    }
  }, [props.open]);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!open) {
      props.changeUserDeialog();
    }
  }, [!open]);

  //tab
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const [usertype, setUsertype] = useState(2);

  const onSubmit = (data) => {
    data["usertype"] = usertype;
    if (userObj.id) {
      if (data.image.length !== 0) {
        var userimage = "";
        let file = data.image[0];
        let reader = new FileReader();
        reader.onloadend = (file) => {
          userimage = reader.result;
          data["userimage"] = userimage;
          axios
            .put("api/user/" + userObj.id, data)
            .then((res) => {
              NotificationManager.success(
                <IntlMessages id="notification.successMessage" />,
                <IntlMessages id="notification.titleHere" />
              );
              setOpen(false);
            })
            .catch((err) => {
              NotificationManager.error(
                <IntlMessages id="notification.errorMessage" />,
                <IntlMessages id="notification.titleHere" />
              );
            });
        };
        reader.readAsDataURL(file);
      } else {
        axios
          .put("api/user/" + userObj.id, data)
          .then((res) => {
            NotificationManager.success(
              <IntlMessages id="notification.successMessage" />,
              <IntlMessages id="notification.titleHere" />
            );
            setOpen(false);
          })
          .catch((err) => {
            NotificationManager.error(
              <IntlMessages id="notification.errorMessage" />,
              <IntlMessages id="notification.titleHere" />
            );
          });
      }
    } else {
      if (data.image.length !== 0) {
        var userimage = "";
        let file = data.image[0];
        let reader = new FileReader();
        reader.onloadend = (file) => {
          userimage = reader.result;
          data["userimage"] = userimage;
          axios
            .post("api/user", data)
            .then((res) => {
              NotificationManager.success(
                <IntlMessages id="notification.successMessage" />,
                <IntlMessages id="notification.titleHere" />
              );
              setOpen(false);
            })
            .catch((err) => {
              NotificationManager.error(
                <IntlMessages id="notification.errorMessage" />,
                <IntlMessages id="notification.titleHere" />
              );
            });
        };
        reader.readAsDataURL(file);
      } else {
        axios
          .post("api/user", data)
          .then((res) => {
            NotificationManager.success(
              <IntlMessages id="notification.successMessage" />,
              <IntlMessages id="notification.titleHere" />
            );
            setOpen(false);
          })
          .catch((err) => {
            NotificationManager.error(
              <IntlMessages id="notification.errorMessage" />,
              <IntlMessages id="notification.titleHere" />
            );
          });
      }
    }
  };

  const [users, setUsers] = useState([]);
  const getUser = () => {
    axios
      .get("api/user")
      .then((res) => {
        setUsers(res.data);
        NotificationManager.success(
          <IntlMessages id="notification.successMessage" />,
          <IntlMessages id="notification.titleHere" />
        );
      })
      .catch((err) => {
        NotificationManager.error(
          <IntlMessages id="notification.errorMessage" />,
          <IntlMessages id="notification.titleHere" />
        );
      });
  };

  const deletUser = (id) => {
    axios
      .delete("api/user/" + id)
      .then((res) => {
        getUser();
        NotificationManager.success(
          <IntlMessages id="notification.successMessage" />,
          <IntlMessages id="notification.titleHere" />
        );
      })
      .catch((err) => {
        NotificationManager.error(
          <IntlMessages id="notification.errorMessage" />,
          <IntlMessages id="notification.titleHere" />
        );
      });
  };

  const [userObj, setUserObj] = React.useState([]);
  const editUser = (rowData) => {
    setUserObj(rowData);
    setValue(1);
    setUsertype(rowData.usertype);
  };

  return (
    <>
      <div>
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          maxWidth="sm"
          fullWidth="sm"
        >
          <DialogContent dividers className="custodialogstyle">
            <AppBar position="static" color="default">
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                aria-label="full width tabs example"
              >
                <Tab label="User List" {...a11yProps(0)} />
                <Tab label="Register User" {...a11yProps(1)} />
              </Tabs>
            </AppBar>
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={value}
              onChangeIndex={handleChangeIndex}
            >
              <TabPanel value={value} index={0} dir={theme.direction}>
                <div className="table-responsive-material">
                  <Table className="default-table table-unbordered table table-sm table-hover">
                    <thead className="table-head-sm th-border-b">
                      <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>User Type</th>
                        <th>Image</th>
                        <th>Setting</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((data, index) => {
                        return (
                          <tr key={index}>
                            {data.name !== "admin" ? (
                              <>
                                <td>{index +1}</td>
                                <td>{data.name}</td>
                                <td>{data.email}</td>
                                <td>
                                  {data.usertype === 1 ? "Admin" : ""}
                                  {data.usertype === 2 ? "Manager" : ""}
                                  {data.usertype === 3 ? "Agent" : ""}
                                </td>

                                <div className="chat-avatar col-xl-2 col-3">
                                  <div className="chat-avatar-mode">
                                    <img
                                      src={`${axios.defaults.baseURL}userimage/${data.image}`}
                                      className="rounded-circle size-40"
                                      alt="Null"
                                    />
                                  </div>
                                </div>
                                <td>
                                  {JSON.parse(localStorage.getItem("UserData"))
                                    .usertype !== 3 ? (
                                    <div className="pointer text-primary">
                                      <span className="d-inline-block mr-1">
                                        <IconButton
                                          size="small"
                                          aria-label="Add Irradiation"
                                          color="inherit"
                                          disabled={data.usertype === 1}
                                          onClick={() => deletUser(data.id)}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </span>

                                      <span className="d-inline-block mr-1">
                                        <IconButton
                                          size="small"
                                          aria-label="Add Irradiation"
                                          color="inherit"
                                          onClick={() => editUser(data)}
                                        >
                                          <EditIcon />
                                        </IconButton>
                                      </span>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              </>
                            ) : (
                              ""
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </TabPanel>
              <TabPanel value={value} index={1} dir={theme.direction}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row mt-2 mb-2">
                    <h3 className="p-2">
                      Register the new User as Manger or agent of the system
                    </h3>
                    <div className="col-xl-6 col-gl-6 col-md-6 col-sm-12 col-12 mt-3">
                      <TextField
                        id="name"
                        name="name"
                        className="form-control"
                        size="small"
                        label="Full Name"
                        variant="outlined"
                        defaultValue={userObj?.name}
                        inputRef={register}
                      />
                    </div>
                    <div className="col-xl-6 col-gl-6 col-md-6 col-sm-12 col-12 mt-3">
                      <TextField
                        id="email"
                        name="email"
                        className="form-control"
                        size="small"
                        label="Email"
                        variant="outlined"
                        defaultValue={userObj?.email}
                        inputRef={register}
                      />
                    </div>
                  </div>

                  <div className="row mt-3 mb-2">
                    <div className="col-xl-6 col-gl-6 col-md-6 col-sm-12 col-12 mt-3">
                      {userObj.id ? (
                        <TextField
                          id="password"
                          name="newpassword"
                          className="form-control"
                          size="small"
                          label="New Password"
                          variant="outlined"
                          type="password"
                          inputRef={register}
                          placeholder="New Password"
                        />
                      ) : (
                        <TextField
                          id="password"
                          name="password"
                          className="form-control"
                          size="small"
                          label="Password"
                          variant="outlined"
                          type="password"
                          inputRef={register}
                        />
                      )}
                    </div>

                    <div className="col-xl-6 col-gl-6 col-md-6 col-sm-12 col-12 mt-3">
                      <div className="radioBtn">
                        {usertype !== 1 ? (
                          <div
                            className="btn-group form-group float-right"
                            role="group"
                            aria-label="Basic radio toggle button group"
                          >
                            <input
                              type="radio"
                              className="btn-check form-control"
                              name="usertype"
                              id="manager"
                              onChange={(e) => setUsertype(e.target.value)}
                              checked={usertype == 2}
                              value="2"
                            />

                            <label
                              className="btn btn-outline-primary"
                              htmlFor="manager"
                            >
                              Manager
                            </label>

                            <input
                              type="radio"
                              className="btn-check form-control"
                              name="usertype"
                              id="agent"
                              onChange={(e) => setUsertype(e.target.value)}
                              checked={usertype == 3}
                              value="3"
                            />

                            <label
                              className="btn btn-outline-primary"
                              htmlFor="agent"
                            >
                              Agent
                            </label>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row mt-2 mb-2">
                    <div className="col-xl-6 col-gl-6 col-md-6 col-sm-12 col-12 ">
                      <TextField
                        id="image"
                        name="image"
                        className="form-control"
                        size="small"
                        variant="outlined"
                        type="file"
                        inputRef={register}
                      />
                    </div>

                    <div className="col-xl-6 col-gl-6 col-md-6 col-sm-12 col-12 ">
                      {userObj.image ? (
                        <span>
                          <img
                            src={`${axios.defaults.baseURL}userimage/${userObj?.image}`}
                            class="img-thumbnail rounded acc_img_width"
                            alt="Responsive"
                          />
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  {userObj.id ? (
                    <Button
                      type="submit"
                      color="primary"
                      variant="contained"
                      className="pull-right mt-3"
                    >
                      Update User Data
                    </Button>
                  ) : JSON.parse(localStorage.getItem("UserData")).usertype !==
                    3 ? (
                    <Button
                      type="submit"
                      color="primary"
                      variant="contained"
                      className="pull-right mt-3"
                    >
                      Register User
                    </Button>
                  ) : (
                    ""
                  )}
                </form>
              </TabPanel>
            </SwipeableViews>
          </DialogContent>
        </Dialog>
      </div>
      <NotificationContainer />
    </>
  );
}
